import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { ManagementContractContext, updateManagementContractContext } from "@eres/ejari-core/contexts/ManagementContractContext";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import FormAction from "@my-dld/components/Form/FormAction";
import FormRow from "@eres/forms-web/FormRow";
import { navigate } from "@my-dld/utils/StoreUtils";
import { IdExtractor, serverDateConverter } from "@my-dld/utils/LookupUtil";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { dualDataManager } from "@eres/forms/valuemanager/DualDataManager";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { LoadableDataState, showErrorMessage } from "@my-dld/utils/UIUtils";
import _ from "lodash";
import { ErrorContainer } from "@eres/forms";
import { checkNonEmpty } from "../../utils";
import { AlphaSortProcessor, EJLookupTransformer, populateLookupOnTo, StateConsumer } from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";
import { Lookup } from "@eres/ejari-api/Entity";
import CurrencyInputField from "@eres/forms-web/CurrencyInputField";
import { valueRenderer } from "../Contract/ContractCalculatedValue";
import DetailsKV from "../DetailsKV";
import { CurrencyUtil, LocaleUtil } from "@eres/core";
import { EJARI_PAYMENT_PLAN_TYPES, PAYMENT_CHEQUE } from "@eres/ejari-api/Entity/contract";
import BigNumber from "bignumber.js";
import RadioInputField from "@eres/forms-web/RadioInputField";
import { MCPaymentDetails } from "@eres/ejari-api/Entity/management_contract";
import TextInputField from "@eres/forms-web/TextInputField";
import DateInputField from "@eres/forms-web/DateInputField";
import moment from "moment";
import PickerInput from "@eres/forms-web/PickerInput";

interface Props extends RoutedViewProps {
}

interface LookupState {
	Banks?: Lookup[];
}

interface State extends LookupState, LoadableDataState {
	newData?: MCPaymentDetails[];
	orgData?: MCPaymentDetails[];
}

class PaymentPlan extends Component<Props, State> {
	paymentRef: PaymentOption[] = [];
	static contextType = ManagementContractContext;
	context!: React.ContextType<typeof ManagementContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "loading",
		};
	}

	componentDidMount(): void {
		this.updateFromContext();
		populateLookupOnTo( EjariLookUp.BANKS, StateConsumer( this, "Banks" ), EJLookupTransformer, AlphaSortProcessor );
	}

	setRef = ( ref: PaymentOption ) => {
		this.paymentRef.push( ref );
	};

	render() {
		const { Banks } = this.state;
		const { payments } = this.context;
		const { contractDetail } = this.context;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			containerClassName: "col-md-6 form-group",
			errorManager: defaultErrorManager,
		};
		return <div className="tender-registration-form">
			<FormSection title={ Strings.payment_details }>
				<div className={ "flex-grid" }>
					<DetailsKV
						label={ Strings.fixed_amount }
						value={ CurrencyUtil.toFormattedCurrency( contractDetail?.FixedFee! ) + " " + Strings.aed }/>
					<DetailsKV
						label={ Strings.payment_count }
						value={ contractDetail?.NoOfPayments }/>
				</div>
				<FormRow { ...filedProps }>
					{ payments?.map( ( _, index ) =>
						<PaymentOption
							key={ index }
							ref={ this.setRef }
							index={ index }
							Banks={ Banks }
							onUpdatePayment={ this.onUpdatePayment }/> ) }
				</FormRow>
			</FormSection>
			<FormRow>
				<FormAction
					primaryActionLabel={ Strings.continue }
					onPrimaryAction={ this.onContinue }
					secondaryActionLabel={ Strings.back }
					onSecondaryAction={ this.onBack }/>
			</FormRow>
		</div>;
	}

	private onUpdatePayment = ( item: MCPaymentDetails, index: number ) => {
		const payments = this.getUpdatedData();
		payments[ index ] = { ...item, PaymentTypeID: ( item.PaymentTypeID as any )?.Id };
		this.setState( { ...this.state, newData: payments.map( p => p! ), } );
	};

	private updateFromContext() {
		const { payments } = this.context;
		const state = {
			orgData: payments || [],
			newData: payments || [],
		};
		this.setState( state );
	}

	private getUpdatedData = ( state: State = this.state ) => {
		const data: MCPaymentDetails[] = [];
		_.merge( data, state.orgData, state.newData );
		return data;
	};

	private isValid() {
		const data = this.getUpdatedData();
		const { contractDetail } = this.context;
		const error: ErrorContainer = {};
		let ta = new BigNumber( contractDetail?.FixedFee! );
		let ca = new BigNumber( 0 );
		let isValid = true;
		let index = 0;
		for ( let payment of data ) {
			isValid = this.paymentRef[ index ].paymentValidator();
			ca = ca.plus( new BigNumber( payment?.PayAmount! ) );
			index++;
		}
		if ( !_.isEqual( ta, ca ) ) {
			showErrorMessage( Strings.total_fees_compare_payment_plan );
			isValid = false;
		}
		this.setState( {
			errorContainer: error,
		} );
		return isValid;
	}

	private onContinue = () => {
		if ( this.isValid() ) {
			const data = this.getUpdatedData();
			updateManagementContractContext( { ...this.context, payments: data } );
			navigate( "responsibilities" );
		}
	};

	private onBack = () => {
		this.props.history.goBack();
	};
}

export default PaymentPlan;

interface PaymentProps extends LookupState {
	index: number;
	onUpdatePayment: ( item: MCPaymentDetails, index: number ) => void;
}

interface PaymentDetails extends MCPaymentDetails {
	[ key: string ]: any;
}

interface PaymentState {
	orgData?: Partial<PaymentDetails>;
	newData?: Partial<PaymentDetails>;
	errorContainer?: ErrorContainer;
}

class PaymentOption extends Component<PaymentProps, PaymentState> {
	static contextType = ManagementContractContext;
	context!: React.ContextType<typeof ManagementContractContext>;

	constructor( props: PaymentProps ) {
		super( props );
		this.state = {};
	}

	componentDidUpdate( prevProps: Readonly<PaymentProps>, prevState: Readonly<PaymentState>, snapshot?: any ) {
		const data = this.getUpdatedData();
		if ( !_.isEqual( data, prevState.newData ) ) {
			const Bank = data[ `BankID_${ this.props.index }` ] as unknown as Lookup;
			this.props.onUpdatePayment( {
				PayAmount: data[ `PayAmount_${ this.props.index }` ],
				BankID: Bank?.Id,
				ChequeNo: data[ `ChequeNo_${ this.props.index }` ],
				DueDate: data[ `DueDate_${ this.props.index }` ],
				PaymentTypeID: data[ `PaymentTypeID_${ this.props.index }` ]
			} as MCPaymentDetails, this.props.index );
		}
	}

	componentDidMount() {
		this.updateFromContext();
	}

	private updateFromContext() {
		const { payments } = this.context;
		const PaymentTypeID = EJARI_PAYMENT_PLAN_TYPES.find( p => p.Id + "" === payments?.[ this.props.index ]?.PaymentTypeID + "" );
		const data = {
			[ `PaymentTypeID_${ this.props.index }` ]: PaymentTypeID as any,
			[ `PayAmount_${ this.props.index }` ]: payments?.[ this.props.index ].PayAmount,
			[ `ChequeNo_${ this.props.index }` ]: payments?.[ this.props.index ].ChequeNo,
			[ `DueDate_${ this.props.index }` ]: payments?.[ this.props.index ].DueDate,
			[ `BankID_${ this.props.index }` ]: payments?.[ this.props.index ].BankID,
		};
		const state: PaymentState = {
			orgData: data,
			newData: data,
		};
		this.setState( state );
	}

	paymentValidator = () => {
		const data = this.getUpdatedData();
		let isValid: boolean = true;
		let errorContainer: ErrorContainer = {};
		isValid = checkNonEmpty( data, `PaymentTypeID_${ this.props.index }`, errorContainer ) && isValid;
		if ( ( data[ `PaymentTypeID_${ this.props.index }` ] as any )?.Id + "" === PAYMENT_CHEQUE.Id + "" ) {
			isValid = checkNonEmpty( data, `ChequeNo_${ this.props.index }`, errorContainer ) && isValid;
			isValid = checkNonEmpty( data, `BankID_${ this.props.index }`, errorContainer ) && isValid;
		}
		isValid = checkNonEmpty( data, `PayAmount_${ this.props.index }`, errorContainer ) && isValid;
		isValid = checkNonEmpty( data, `DueDate_${ this.props.index }`, errorContainer ) && isValid;
		this.setState( {
			errorContainer: errorContainer,
		} );
		return isValid;
	};

	render() {
		const { Banks } = this.props;
		const data = this.getUpdatedData();
		const today = moment().toDate();
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			containerClassName: "col-md-6 form-group",
			errorManager: defaultErrorManager,
			holder: StateHolder.buildStateHolder( this ),
			required: true,
		};
		return <>
			<RadioInputField
				{ ...filedProps }
				containerClassName={ "col-12 form-group" }
				id={ `PaymentTypeID_${ this.props.index }` }
				toIdentifier={ IdExtractor }
				label={ "" }
				valueManager={ dualDataManager }
				required={ false }
				items={ EJARI_PAYMENT_PLAN_TYPES }
				formatter={ ( val: any ) => LocaleUtil.getLocalValue( val.Name ) }
			/>
			{ ( data[ `PaymentTypeID_${ this.props.index }` ] as any )?.Id + "" === PAYMENT_CHEQUE.Id + "" ? <>
				<TextInputField
					{ ...filedProps }
					label={ Strings.chq_nb }
					required={ true }
					valueManager={ dualDataManager }
					id={ `ChequeNo_${ this.props.index }` }/>
				<PickerInput
					{ ...filedProps }
					toIdentifier={ IdExtractor }
					id={ `BankID_${ this.props.index }` }
					isLoading={ Banks == null }
					valueManager={ dualDataManager }
					required={ true }
					label={ Strings.bank_name }
					items={ Banks }/>
			</> : null }
			<CurrencyInputField
				{ ...filedProps }
				label={ Strings.amount }
				required={ true }
				textRenderer={ valueRenderer }
				valueManager={ dualDataManager }
				id={ `PayAmount_${ this.props.index }` }/>
			<DateInputField
				label={ Strings.due_date }
				{ ...filedProps }
				id={ `DueDate_${ this.props.index }` }
				required={ true }
				valueManager={ dualDataManager }
				extraOpts={ { minDate: today } }
				inputProps={ { autoComplete: "off" } }
				valueConverter={ serverDateConverter }/>
		</>;
	}

	private getUpdatedData = ( state: PaymentState = this.state ) => {
		const data: Partial<PaymentDetails> = {};
		_.merge( data, state.orgData, state.newData );
		return data;
	};
}